// React imports
import React from 'react';

// UI – style imports
import { WithStyles, withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './Community.style';
import Video from 'components/Video';
import videoFundas from 'images/videos/historias_cuenca_open_source.mp4';
import videoPoster from 'images/frame-open-source.png';

function Community(props: WithStyles<typeof styles>) {
    const { classes } = props;
    return (
        <Box className={classes.root}>
            <Box className={classes.video}>
                <Video url={videoFundas} imagePreview={videoPoster} title="Historias Cuenca: La Funda de una Tarjeta" />
            </Box>
        </Box>
    );
}

export default withStyles(styles)(Community);
